import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const collapsibles = document.querySelectorAll<HTMLAnchorElement>(constants.targets.collapseTrigger);

    collapsibles.forEach((collapsible: HTMLAnchorElement) => {
        collapsible.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();

            const targetSelector: string | null = collapsible.getAttribute('href');
            if (!targetSelector) return;

            const target = document.querySelector<HTMLElement>(targetSelector);
            if (!target) return;

            const isActive = target.classList.contains(constants.classes.active);

            if (isActive) {
                target.style.maxHeight = '0';
                target.classList.remove(constants.classes.active);
                collapsible.classList.remove(constants.classes.active);
                collapsible.ariaExpanded = 'false';
            } else {
                target.style.maxHeight = target.scrollHeight + 'px';
                target.classList.add(constants.classes.active);
                collapsible.classList.add(constants.classes.active);
                collapsible.ariaExpanded = 'true';
            }
        });
    });
});
